import { apiBaseUrl } from 'app/src/msw/membership/api/apiBaseUrl'
import { getMockUserInfoByTenantId } from 'app/src/msw/stories/common-stories-mock'
import type { membershipApi } from 'app/src/services/welfareportal'
import { http, HttpResponse, type DefaultBodyType } from 'msw'

export const getUserInfo = http.get<object, DefaultBodyType, membershipApi.UserInfo>(apiBaseUrl + '/users/info', async () => {
  const jsonData = await getMockUserInfoByTenantId()
  return new HttpResponse(JSON.stringify(jsonData), {
    status: 200,
    headers: {
      'Content-Type': 'application/json',
    },
  })
})
